module.exports = __webpack_public_path__ + "static/media/Cabin.46d73c23.ttf";